module.exports = __webpack_public_path__ + "media/images/ln/constellation_02-f237ca8a88133e5def88b10ffcc2f5d5.png";